import React from 'react';

import { BaseIconProps } from '.';

export const ArrowPointingToTopRight = ({ fill }: BaseIconProps) => (
  <path
    fill={fill}
    d="M706.3,219.7L1.3,924.7L156.7,1080l698.2-698.3v436.7h219.5L1078.7,0H269.9v219.7H706.3z"
  />
);
